require("core-js/modules/es.array.sort.js");
module.exports = function (t) {
  function e(r) {
    if (a[r]) return a[r].exports;
    var n = a[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(n.exports, n, n.exports, e), n.l = !0, n.exports;
  }
  var a = {};
  return e.m = t, e.c = a, e.d = function (t, a, r) {
    e.o(t, a) || Object.defineProperty(t, a, {
      configurable: !1,
      enumerable: !0,
      get: r
    });
  }, e.n = function (t) {
    var a = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return e.d(a, "a", a), a;
  }, e.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, e.p = "", e(e.s = 10);
}([function (t, e, a) {
  "use strict";

  function r(t, e) {
    return !!t.children(e).length;
  }
  function n(t) {
    return l(t.v) + ":" + l(t.w) + ":" + l(t.name);
  }
  function l(t) {
    return t ? String(t).replace(f, "\\:") : "";
  }
  function d(t, e) {
    e && t.attr("style", e);
  }
  function u(t, e, a) {
    e && t.attr("class", e).attr("class", a + " " + t.attr("class"));
  }
  function i(t, e) {
    var a = e.graph();
    if (s.default.isPlainObject(a)) {
      var r = a.transition;
      if (s.default.isFunction(r)) return r(t);
    }
    return t;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var o = a(2),
    s = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(o),
    f = /:/g;
  e.default = {
    isSubgraph: r,
    edgeToId: n,
    applyStyle: d,
    applyClass: u,
    applyTransition: i
  };
}, function (t, e) {
  t.exports = require("d3");
}, function (t, e) {
  t.exports = require("lodash");
}, function (t, e, a) {
  "use strict";

  function r(t, e, a, r) {
    var n = t.x,
      l = t.y,
      d = n - r.x,
      u = l - r.y,
      i = Math.sqrt(e * e * u * u + a * a * d * d),
      o = Math.abs(e * a * d / i);
    r.x < n && (o = -o);
    var s = Math.abs(e * a * u / i);
    return r.y < l && (s = -s), {
      x: n + o,
      y: l + s
    };
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
}, function (t, e, a) {
  "use strict";

  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function n(t, e, a) {
    var r = e.label,
      n = t.append("g");
    "svg" === e.labelType ? (0, s.default)(n, e) : "string" != typeof r || "html" === e.labelType ? (0, i.default)(n, e) : (0, d.default)(n, e);
    var l = n.node().getBBox(),
      u = void 0;
    switch (a) {
      case "top":
        u = -e.height / 2;
        break;
      case "bottom":
        u = e.height / 2 - l.height;
        break;
      default:
        u = -l.height / 2;
    }
    return n.attr("transform", "translate(" + -l.width / 2 + "," + u + ")"), n;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var l = a(19),
    d = r(l),
    u = a(20),
    i = r(u),
    o = a(21),
    s = r(o);
  e.default = n;
}, function (t, e) {
  t.exports = require("dagre-layout");
}, function (t, e, a) {
  "use strict";

  function r(t, e) {
    return t.intersect(e);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
}, function (t, e, a) {
  "use strict";

  function r(t, e, a) {
    return (0, l.default)(t, e, e, a);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = a(3),
    l = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n);
  e.default = r;
}, function (t, e, a) {
  "use strict";

  function r(t, e, a) {
    var r = t.x,
      n = t.y,
      d = [],
      u = Number.POSITIVE_INFINITY,
      i = Number.POSITIVE_INFINITY;
    e.forEach(function (t) {
      u = Math.min(u, t.x), i = Math.min(i, t.y);
    });
    for (var o = r - t.width / 2 - u, s = n - t.height / 2 - i, f = 0; f < e.length; f += 1) {
      var c = e[f],
        p = e[f < e.length - 1 ? f + 1 : 0],
        h = (0, l.default)(t, a, {
          x: o + c.x,
          y: s + c.y
        }, {
          x: o + p.x,
          y: s + p.y
        });
      h && d.push(h);
    }
    return d.length ? (d.length > 1 && d.sort(function (t, e) {
      var r = t.x - a.x,
        n = t.y - a.y,
        l = Math.sqrt(r * r + n * n),
        d = e.x - a.x,
        u = e.y - a.y,
        i = Math.sqrt(d * d + u * u);
      return l < i ? -1 : l === i ? 0 : 1;
    }), d[0]) : (console.log("NO INTERSECTION FOUND, RETURN NODE CENTER", t), t);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = a(13),
    l = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n);
  e.default = r;
}, function (t, e, a) {
  "use strict";

  function r(t, e) {
    var a = t.x,
      r = t.y,
      n = e.x - a,
      l = e.y - r,
      d = t.width / 2,
      u = t.height / 2,
      i = void 0,
      o = void 0;
    return Math.abs(l) * d > Math.abs(n) * u ? (l < 0 && (u = -u), i = 0 === l ? 0 : u * n / l, o = u) : (n < 0 && (d = -d), i = d, o = 0 === n ? 0 : d * l / n), {
      x: a + i,
      y: r + o
    };
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
}, function (t, e, a) {
  "use strict";

  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = a(1),
    l = r(n),
    d = a(11),
    u = r(d),
    i = a(5),
    o = r(i),
    s = a(12),
    f = r(s),
    c = a(14),
    p = r(c),
    h = a(0),
    y = r(h),
    g = a(27);
  e.default = {
    d3: l.default,
    graphlib: u.default,
    dagre: o.default,
    intersect: f.default,
    render: p.default,
    util: y.default,
    version: g.version
  };
}, function (t, e) {
  t.exports = require("graphlib");
}, function (t, e, a) {
  "use strict";

  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = a(6),
    l = r(n),
    d = a(7),
    u = r(d),
    i = a(3),
    o = r(i),
    s = a(8),
    f = r(s),
    c = a(9),
    p = r(c);
  e.default = {
    node: l.default,
    circle: u.default,
    ellipse: o.default,
    polygon: f.default,
    rect: p.default
  };
}, function (t, e, a) {
  "use strict";

  function r(t, e, a, r) {
    var l = e.y - t.y,
      d = t.x - e.x,
      u = e.x * t.y - t.x * e.y,
      i = l * a.x + d * a.y + u,
      o = l * r.x + d * r.y + u;
    if (0 === i || 0 === o || !n(i, o)) {
      var s = r.y - a.y,
        f = a.x - r.x,
        c = r.x * a.y - a.x * r.y,
        p = s * t.x + f * t.y + c,
        h = s * e.x + f * e.y + c;
      if (0 === p || 0 === h || !n(p, h)) {
        var y = l * f - s * d;
        if (0 !== y) {
          var g = Math.abs(y / 2),
            v = d * c - f * u,
            b = v < 0 ? (v - g) / y : (v + g) / y;
          v = s * u - l * c;
          return {
            x: b,
            y: v < 0 ? (v - g) / y : (v + g) / y
          };
        }
      }
    }
  }
  function n(t, e) {
    return t * e > 0;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
}, function (t, e, a) {
  "use strict";

  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function n() {
    var t = b.default,
      e = m.default,
      a = w.default,
      r = k.default,
      n = j.default,
      i = P.default,
      o = function (o, f) {
        l(f);
        var p = u(o, "output"),
          y = u(p, "clusters"),
          v = u(p, "edgePaths"),
          b = a(u(p, "edgeLabels"), f),
          _ = t(u(p, "nodes"), f, n);
        (0, s.layout)(f), (0, c.default)(_, f), (0, h.default)(b, f), r(v, f, i);
        var m = e(y, f);
        (0, g.default)(m, f), d(f);
      };
    return o.createNodes = function (e) {
      return arguments.length ? (t = e, o) : t;
    }, o.createClusters = function (t) {
      return arguments.length ? (e = t, o) : e;
    }, o.createEdgeLabels = function (t) {
      return arguments.length ? (a = t, o) : a;
    }, o.createEdgePaths = function (t) {
      return arguments.length ? (r = t, o) : r;
    }, o.shapes = function (t) {
      return arguments.length ? (n = t, o) : n;
    }, o.arrows = function (t) {
      return arguments.length ? (i = t, o) : i;
    }, o;
  }
  function l(t) {
    t.nodes().forEach(function (e) {
      var a = t.node(e);
      o.default.has(a, "label") || t.children(e).length || (a.label = e), o.default.has(a, "paddingX") && o.default.defaults(a, {
        paddingLeft: a.paddingX,
        paddingRight: a.paddingX
      }), o.default.has(a, "paddingY") && o.default.defaults(a, {
        paddingTop: a.paddingY,
        paddingBottom: a.paddingY
      }), o.default.has(a, "padding") && o.default.defaults(a, {
        paddingLeft: a.padding,
        paddingRight: a.padding,
        paddingTop: a.padding,
        paddingBottom: a.padding
      }), o.default.defaults(a, S), o.default.each(["paddingLeft", "paddingRight", "paddingTop", "paddingBottom"], function (t) {
        a[t] = Number(a[t]);
      }), o.default.has(a, "width") && (a._prevWidth = a.width), o.default.has(a, "height") && (a._prevHeight = a.height);
    }), t.edges().forEach(function (e) {
      var a = t.edge(e);
      o.default.has(a, "label") || (a.label = ""), o.default.defaults(a, I);
    });
  }
  function d(t) {
    o.default.each(t.nodes(), function (e) {
      var a = t.node(e);
      o.default.has(a, "_prevWidth") ? a.width = a._prevWidth : delete a.width, o.default.has(a, "_prevHeight") ? a.height = a._prevHeight : delete a.height, delete a._prevWidth, delete a._prevHeight;
    });
  }
  function u(t, e) {
    var a = t.select("g." + e);
    return a.empty() && (a = t.append("g").attr("class", e)), a;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var i = a(2),
    o = r(i),
    s = a(5),
    f = a(15),
    c = r(f),
    p = a(16),
    h = r(p),
    y = a(17),
    g = r(y),
    v = a(18),
    b = r(v),
    _ = a(22),
    m = r(_),
    x = a(23),
    w = r(x),
    M = a(24),
    k = r(M),
    T = a(25),
    j = r(T),
    O = a(26),
    P = r(O),
    S = {
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      rx: 0,
      ry: 0,
      shape: "rect"
    },
    I = {
      arrowhead: "normal",
      lineInterpolate: "linear"
    };
  e.default = n;
}, function (t, e, a) {
  "use strict";

  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function n(t, e) {
    function a(t) {
      var a = e.node(t);
      return "translate(" + a.x + "," + a.y + ")";
    }
    t.filter(function () {
      return !d.default.select(this).classed("update");
    }).attr("transform", a), i.default.applyTransition(t, e).style("opacity", 1).attr("transform", a);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var l = a(1),
    d = r(l),
    u = a(0),
    i = r(u);
  e.default = n;
}, function (t, e, a) {
  "use strict";

  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function n(t, e) {
    function a(t) {
      var a = e.edge(t);
      return i.default.has(a, "x") ? "translate(" + a.x + "," + a.y + ")" : "";
    }
    t.filter(function () {
      return !d.default.select(this).classed("update");
    }).attr("transform", a), s.default.applyTransition(t, e).style("opacity", 1).attr("transform", a);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var l = a(1),
    d = r(l),
    u = a(2),
    i = r(u),
    o = a(0),
    s = r(o);
  e.default = n;
}, function (t, e, a) {
  "use strict";

  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function n(t, e) {
    function a(t) {
      var a = e.node(t);
      return "translate(" + a.x + "," + a.y + ")";
    }
    var r = t.filter(function () {
      return !d.default.select(this).classed("update");
    });
    r.attr("transform", a), i.default.applyTransition(t, e).style("opacity", 1).attr("transform", a), i.default.applyTransition(r.selectAll("rect"), e).attr("width", function (t) {
      return e.node(t).width;
    }).attr("height", function (t) {
      return e.node(t).height;
    }).attr("x", function (t) {
      return -e.node(t).width / 2;
    }).attr("y", function (t) {
      return -e.node(t).height / 2;
    });
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var l = a(1),
    d = r(l),
    u = a(0),
    i = r(u);
  e.default = n;
}, function (t, e, a) {
  "use strict";

  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function n(t, e, a) {
    var r = e.nodes().filter(function (t) {
        return !c.default.isSubgraph(e, t);
      }),
      n = t.selectAll("g.node").data(r, function (t) {
        return t;
      }).classed("update", !0);
    return n.selectAll("*").remove(), n.enter().append("g").attr("class", "node").style("opacity", 0), n.each(function (t) {
      var r = e.node(t),
        n = i.default.select(this),
        l = n.append("g").attr("class", "label"),
        u = (0, s.default)(l, r),
        o = a[r.shape],
        f = d.default.pick(u.node().getBBox(), "width", "height");
      r.elem = this, r.id && n.attr("id", r.id), r.labelId && l.attr("id", r.labelId), c.default.applyClass(n, r.class, (n.classed("update") ? "update " : "") + "node"), d.default.has(r, "width") && (f.width = r.width), d.default.has(r, "height") && (f.height = r.height), f.width += r.paddingLeft + r.paddingRight, f.height += r.paddingTop + r.paddingBottom, l.attr("transform", "translate(" + (r.paddingLeft - r.paddingRight) / 2 + "," + (r.paddingTop - r.paddingBottom) / 2 + ")");
      var p = o(i.default.select(this), f, r);
      c.default.applyStyle(p, r.style);
      var h = p.node().getBBox();
      r.width = h.width, r.height = h.height;
    }), c.default.applyTransition(n.exit(), e).style("opacity", 0).remove(), n;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var l = a(2),
    d = r(l),
    u = a(1),
    i = r(u),
    o = a(4),
    s = r(o),
    f = a(0),
    c = r(f);
  e.default = n;
}, function (t, e, a) {
  "use strict";

  function r(t, e) {
    for (var a = t.append("text"), r = n(e.label).split("\n"), l = 0; l < r.length; l += 1) a.append("tspan").attr("xml:space", "preserve").attr("dy", "1em").attr("x", "1").text(r[l]);
    return d.default.applyStyle(a, e.labelStyle), a;
  }
  function n(t) {
    for (var e = "", a = !1, r = null, n = 0; n < t.length; n += 1) if (r = t[n], a) {
      switch (r) {
        case "n":
          e += "\n";
          break;
        default:
          e += r;
      }
      a = !1;
    } else "\\" === r ? a = !0 : e += r;
    return e;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var l = a(0),
    d = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(l);
  e.default = r;
}, function (t, e, a) {
  "use strict";

  function r(t, e) {
    var a = t.append("foreignObject").attr("width", "100000"),
      r = a.append("xhtml:div");
    r.attr("xmlns", "http://www.w3.org/1999/xhtml");
    var l = e.label;
    switch (void 0 === l ? "undefined" : n(l)) {
      case "function":
        r.insert(l);
        break;
      case "object":
        r.insert(function () {
          return l;
        });
        break;
      default:
        r.html(l);
    }
    d.default.applyStyle(r, e.labelStyle), r.style("display", "inline-block"), r.style("white-space", "nowrap");
    var u = r[0][0].getBoundingClientRect();
    return a.attr("width", u.width).attr("height", u.height), a;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    },
    l = a(0),
    d = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(l);
  e.default = r;
}, function (t, e, a) {
  "use strict";

  function r(t, e) {
    var a = t;
    return a.node().appendChild(e.label), l.default.applyStyle(a, e.labelStyle), a;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = a(0),
    l = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n);
  e.default = r;
}, function (t, e, a) {
  "use strict";

  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function n(t, e) {
    var a = e.nodes().filter(function (t) {
        return i.default.isSubgraph(e, t);
      }),
      r = t.selectAll("g.cluster").data(a, function (t) {
        return t;
      });
    return r.selectAll("*").remove(), r.enter().append("g").attr("class", "cluster").attr("id", function (t) {
      return e.node(t).id;
    }).style("opacity", 0), i.default.applyTransition(r, e).style("opacity", 1), r.each(function (t) {
      var a = e.node(t),
        r = d.default.select(this);
      d.default.select(this).append("rect");
      var n = r.append("g").attr("class", "label");
      (0, s.default)(n, a, a.clusterLabelPos);
    }), r.selectAll("rect").each(function (t) {
      var a = e.node(t),
        r = d.default.select(this);
      i.default.applyStyle(r, a.style);
    }), i.default.applyTransition(r.exit(), e).style("opacity", 0).remove(), r;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var l = a(1),
    d = r(l),
    u = a(0),
    i = r(u),
    o = a(4),
    s = r(o);
  e.default = n;
}, function (t, e, a) {
  "use strict";

  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function n(t, e) {
    var a = t.selectAll("g.edgeLabel").data(e.edges(), function (t) {
      return c.default.edgeToId(t);
    }).classed("update", !0);
    return a.selectAll("*").remove(), a.enter().append("g").classed("edgeLabel", !0).style("opacity", 0), a.each(function (t) {
      var a = e.edge(t),
        r = (0, s.default)(d.default.select(this), e.edge(t), 0, 0).classed("label", !0),
        n = r.node().getBBox();
      a.labelId && r.attr("id", a.labelId), i.default.has(a, "width") || (a.width = n.width), i.default.has(a, "height") || (a.height = n.height);
    }), c.default.applyTransition(a.exit(), e).style("opacity", 0).remove(), a;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var l = a(1),
    d = r(l),
    u = a(2),
    i = r(u),
    o = a(4),
    s = r(o),
    f = a(0),
    c = r(f);
  e.default = n;
}, function (t, e, a) {
  "use strict";

  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function n(t, e, a) {
    var r = t.selectAll("g.edgePath").data(e.edges(), function (t) {
      return v.default.edgeToId(t);
    }).classed("update", !0);
    return i(r, e), o(r, e), v.default.applyTransition(r, e).style("opacity", 1), r.each(function (t) {
      var a = f.default.select(this),
        r = e.edge(t);
      r.elem = this, r.id && a.attr("id", r.id), v.default.applyClass(a, r.class, (a.classed("update") ? "update " : "") + "edgePath");
    }), r.selectAll("path.path").each(function (t) {
      var a = e.edge(t);
      a.arrowheadId = p.default.uniqueId("arrowhead");
      var r = f.default.select(this).attr("marker-end", function () {
        return "url(#" + a.arrowheadId + ")";
      }).style("fill", "none");
      v.default.applyTransition(r, e).attr("d", function (t) {
        return l(e, t);
      }), v.default.applyStyle(r, a.style);
    }), r.selectAll("defs *").remove(), r.selectAll("defs").each(function (t) {
      var r = e.edge(t);
      (0, a[r.arrowhead])(f.default.select(this), r.arrowheadId, r, "arrowhead");
    }), r;
  }
  function l(t, e) {
    var a = t.edge(e),
      r = t.node(e.v),
      n = t.node(e.w),
      l = a.points.slice(1, a.points.length - 1);
    return l.unshift((0, y.default)(r, l[0])), l.push((0, y.default)(n, l[l.length - 1])), d(a, l);
  }
  function d(t, e) {
    var a = f.default.svg.line().x(function (t) {
      return t.x;
    }).y(function (t) {
      return t.y;
    });
    return p.default.has(t, "lineInterpolate") && a.interpolate(t.lineInterpolate), p.default.has(t, "lineTension") && a.tension(Number(t.lineTension)), a(e);
  }
  function u(t) {
    var e = t.getBBox(),
      a = t.ownerSVGElement.getScreenCTM().inverse().multiply(t.getScreenCTM()).translate(e.width / 2, e.height / 2);
    return {
      x: a.e,
      y: a.f
    };
  }
  function i(t, e) {
    var a = t.enter().append("g").attr("class", "edgePath").style("opacity", 0);
    a.append("path").attr("class", "path").attr("d", function (t) {
      var a = e.edge(t),
        r = e.node(t.v).elem;
      return d(a, p.default.range(a.points.length).map(function () {
        return u(r);
      }));
    }), a.append("defs");
  }
  function o(t, e) {
    var a = t.exit();
    v.default.applyTransition(a, e).style("opacity", 0).remove(), v.default.applyTransition(a.select("path.path"), e).attr("d", function (t) {
      var a = e.node(t.v);
      if (a) {
        return d({}, p.default.range(this.getTotalLength()).map(function () {
          return a;
        }));
      }
      return f.default.select(this).attr("d");
    });
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var s = a(1),
    f = r(s),
    c = a(2),
    p = r(c),
    h = a(6),
    y = r(h),
    g = a(0),
    v = r(g);
  e.default = n;
}, function (t, e, a) {
  "use strict";

  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function n(t, e, a) {
    var r = t.insert("rect", ":first-child").attr("rx", a.rx).attr("ry", a.ry).attr("x", -e.width / 2).attr("y", -e.height / 2).attr("width", e.width).attr("height", e.height);
    return a.intersect = function (t) {
      return (0, o.default)(a, t);
    }, r;
  }
  function l(t, e, a) {
    var r = e.width / 2,
      n = e.height / 2,
      l = t.insert("ellipse", ":first-child").attr("x", -e.width / 2).attr("y", -e.height / 2).attr("rx", r).attr("ry", n);
    return a.intersect = function (t) {
      return (0, f.default)(a, r, n, t);
    }, l;
  }
  function d(t, e, a) {
    var r = Math.max(e.width, e.height) / 2,
      n = t.insert("circle", ":first-child").attr("x", -e.width / 2).attr("y", -e.height / 2).attr("r", r);
    return a.intersect = function (t) {
      return (0, p.default)(a, r, t);
    }, n;
  }
  function u(t, e, a) {
    var r = e.width * Math.SQRT2 / 2,
      n = e.height * Math.SQRT2 / 2,
      l = [{
        x: 0,
        y: -n
      }, {
        x: -r,
        y: 0
      }, {
        x: 0,
        y: n
      }, {
        x: r,
        y: 0
      }],
      d = t.insert("polygon", ":first-child").attr("points", l.map(function (t) {
        return t.x + "," + t.y;
      }).join(" "));
    return a.intersect = function (t) {
      return (0, y.default)(a, l, t);
    }, d;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var i = a(9),
    o = r(i),
    s = a(3),
    f = r(s),
    c = a(7),
    p = r(c),
    h = a(8),
    y = r(h);
  e.default = {
    rect: n,
    ellipse: l,
    circle: d,
    diamond: u
  };
}, function (t, e, a) {
  "use strict";

  function r(t, e, a, r) {
    var n = t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto"),
      l = n.append("path").attr("d", "M 0 0 L 10 5 L 0 10 z").style("stroke-width", 1).style("stroke-dasharray", "1,0");
    u.default.applyStyle(l, a[r + "Style"]), a[r + "Class"] && l.attr("class", a[r + "Class"]);
  }
  function n(t, e, a, r) {
    var n = t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto"),
      l = n.append("path").attr("d", "M 0 0 L 10 5 L 0 10 L 4 5 z").style("stroke-width", 1).style("stroke-dasharray", "1,0");
    u.default.applyStyle(l, a[r + "Style"]), a[r + "Class"] && l.attr("class", a[r + "Class"]);
  }
  function l(t, e, a, r) {
    var n = t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto"),
      l = n.append("path").attr("d", "M 0 5 L 10 5").style("stroke-width", 1).style("stroke-dasharray", "1,0");
    u.default.applyStyle(l, a[r + "Style"]), a[r + "Class"] && l.attr("class", a[r + "Class"]);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var d = a(0),
    u = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(d);
  e.default = {
    normal: r,
    vee: n,
    undirected: l,
    default: r
  };
}, function (t, e) {
  t.exports = {
    name: "dagre-d3-renderer",
    version: "0.4.26",
    description: "A D3-based renderer for Dagre",
    keywords: ["graph", "dagre", "graphlib", "renderer", "d3"],
    main: "dist/dagre-d3.core.js",
    scripts: {
      lint: "standard",
      karma: "node -r babel-register ./node_modules/.bin/karma start --single-run",
      test: "yarn lint && yarn karma && phantomjs test/demo-test.js",
      upgrade: "yarn-upgrade-all && yarn remove d3 && yarn add d3@3.5.17",
      build: "webpack --progress --colors",
      "build:watch": "yarn build --watch",
      release: "yarn build -p"
    },
    dependencies: {
      d3: "3.5.17",
      "dagre-layout": "^0.8.0",
      graphlib: "^2.1.1",
      lodash: "^4.17.4"
    },
    devDependencies: {
      "babel-core": "^6.26.0",
      "babel-loader": "^7.1.2",
      "babel-preset-env": "^1.6.1",
      chai: "^4.1.2",
      karma: "^1.7.1",
      "karma-chrome-launcher": "^2.2.0",
      "karma-firefox-launcher": "^1.1.0",
      "karma-mocha": "^1.3.0",
      "karma-safari-launcher": "^1.0.0",
      mocha: "^4.0.1",
      "phantomjs-prebuilt": "^2.1.16",
      standard: "^10.0.3",
      webpack: "^3.10.0",
      "webpack-node-externals": "^1.6.0",
      "yarn-upgrade-all": "^0.2.0"
    },
    repository: {
      type: "git",
      url: "https://github.com/tylingsoft/dagre-d3-renderer.git"
    },
    license: "MIT",
    standard: {
      ignore: ["dist/**/*.js"]
    }
  };
}]);